<app-dropdown-button *ngIf="currentLanguage" [btnImageUrl]="'/assets/flags/' + currentLanguage.flag +'.svg'">
    <li app-dropdown-button-item *ngFor="let l of languages" (click)="changeLanguage(l)">
        <img [src]="'/assets/flags/' + l.flag +'.svg'">
        <span class="flag-label" [i18n]="'languages.' + l.labelKey"></span>
    </li>
</app-dropdown-button>
